export default function flipBool(value: boolean): boolean {
  return !value;
}
